export const items = (state) => state.items
export const itemDiscount = (state) => state.item_discount
export const SIDE_MENU = (state) => state.side_menu
